export default __webpack_public_path__ + "static/media/reject_sug.ee6e7714.svg";